import { effect, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  menuShrunk = signal(localStorage.getItem('menuShrunk') === 'true');

  constructor() {
    effect(() => {
      localStorage.setItem('menuShrunk', String(this.menuShrunk()));
    });
  }
}
